import { createStore } from 'vuex';

import { Auth } from './modules';

export default createStore({
    modules:
    {
        Auth,
    },
    state: {}
});
